module.exports = __webpack_public_path__ + "img/brand_7.605888c5.png";